import React from "react"
import { useCustomQuery } from "hooks/useCustomQuery"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { Outlet, useNavigate, useParams } from "react-router-dom"
import { AdminOffersService } from "services/api-service"
import { AdminOfferType } from "services/api-service/types"
import { RootState } from "store/store"
import { Row } from "ui/components/atoms/_atoms"
import { IconButton } from "ui/components/atoms/button"
import { H2 } from "ui/components/atoms/typography"
import OfferDetails from "views/Admin/Offers/OfferDetails"

const OfferInfo = () => {
  const { t } = useTranslation(["panel", "common"])
  const navigate = useNavigate()
  const { offerId = "" } = useParams()

  const { profile } = useSelector((state: RootState) => state.profile)

  const { isLoading, data } = useCustomQuery<AdminOfferType>({ key: ["offer", offerId] }, () =>
    AdminOffersService.getOffer(offerId),
  )

  return (
    <>
      <Row $alignItems="center">
        <IconButton
          $background="background"
          $size="45px"
          $iconSize="L"
          $borderRadius="borderRadius"
          onClick={() => navigate(-1)}
          icon="arrow-left"
          $marginRight="S"
          ariaLabel="Go back"
        />
        <H2 $marginBottom="0">{data?.name}</H2>
      </Row>
      <OfferDetails loading={isLoading} data={data} />
      <Outlet />
    </>
  )
}

export default OfferInfo
